import React from 'react'
import PropTypes from 'prop-types'
import isEqualWith from 'lodash/isEqualWith'

import siteConfig from '../../../../common/utils/siteConfig'
import { reportProductsImpressions } from '../../../../common/analytics/resultAnalytics'
import ProductList from '../../../components/productList'
import { itemDecorator } from './utils'

class SearchResultBody extends React.Component {
  reportProductsImpressions (prevMatches) {
    const { matches, currentSite } = this.props
    const compareFunction = (prevMatches, matches) => {
      prevMatches = prevMatches.map(item => item.id)
      matches = matches.map(item => item.id)
      return isEqualWith(prevMatches, matches)
    }

    if (!isEqualWith(prevMatches, matches, compareFunction)) {
      reportProductsImpressions(matches, currentSite)
    }
  }

  componentDidMount () {
    const { matches, currentSite } = this.props
    reportProductsImpressions(matches, currentSite)
  }

  componentDidUpdate (prevProps) {
    this.reportProductsImpressions(prevProps.matches)
  }

  render () {
    const {
      matches,
      createFavoriteCollection,
      currentSite,
      collections,
      cartItems,
      token,
      deleteBookmark,
      addBookmark,
      favoriteCollectionID,
      openModal,
      location,
      preferences
    } = this.props

    const pageSize = siteConfig(currentSite, 'common.search_page_size')

    return <ProductList
      items={matches}
      currentSite={currentSite}
      preferences={preferences}
      itemDecorator={itemDecorator(currentSite, openModal, !token, favoriteCollectionID, collections, deleteBookmark, addBookmark, createFavoriteCollection, pageSize, cartItems, location)}
    />
  }
}

SearchResultBody.propTypes = {
  matches: PropTypes.array.isRequired,
  view: PropTypes.string
}

export default SearchResultBody



// WEBPACK FOOTER //
// ./client/pages/search/result/searchResultBody.js